"use client"
import Link from 'next/link';
import React from 'react';

const DomainSection = () => {
  const domains = [
    { name: 'Domain Registration', href: '/country-domains/registration' },
    { name: 'Bulk Registration', href: '/bulk-registration' },
    { name: 'Domain Transfer', href: process.env.NEXT_PUBLIC_API_BASE_URL+'/cart.php?a=add&domain=transfer' },
    { name: 'Domain Renewal', href: process.env.NEXT_PUBLIC_API_BASE_URL+'/cart.php?gid=renewals' },
  ];

  return (
    <div className="custMargin">
      <div className="container text-center">
        <h2 className="textHad fw-bold fs-3">Domain Stuff</h2>
        <div className="row justify-content-center">
          {domains.map((domain, index) => (
            <div key={index} className="col-lg-2 col-md-2 col-12 d-flex">
              <Link href={domain.href} className="text-decoration-none my-3 d-block mx-0">
                <div className="custDom textHad fs-6 fw-bold ">{domain.name}</div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DomainSection;
